
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.6.0
 * Query Engine version: f676762280b54cd07c770017ed3711ddde35f37a
 */
Prisma.prismaVersion = {
  client: "6.6.0",
  engine: "f676762280b54cd07c770017ed3711ddde35f37a"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.AreaScalarFieldEnum = {
  id: 'id',
  displayName: 'displayName',
  order: 'order',
  themeColor: 'themeColor',
  latitude: 'latitude',
  longitude: 'longitude'
};

exports.Prisma.AreaOpeningHourScalarFieldEnum = {
  id: 'id',
  startTime: 'startTime',
  endTime: 'endTime',
  areaId: 'areaId'
};

exports.Prisma.BandApplicationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  email: 'email',
  bandname: 'bandname',
  genre: 'genre',
  city: 'city',
  facebook: 'facebook',
  demo: 'demo',
  description: 'description',
  numberOfArtists: 'numberOfArtists',
  numberOfNonMaleArtists: 'numberOfNonMaleArtists',
  contactName: 'contactName',
  contactPhone: 'contactPhone',
  knowsKultFrom: 'knowsKultFrom',
  distance: 'distance',
  facebookLikes: 'facebookLikes',
  website: 'website',
  genreCategory: 'genreCategory',
  heardAboutBookingFrom: 'heardAboutBookingFrom',
  contactedByViewerId: 'contactedByViewerId',
  instagram: 'instagram',
  instagramFollower: 'instagramFollower',
  eventId: 'eventId',
  hasPreviouslyPlayed: 'hasPreviouslyPlayed',
  lastContactedAt: 'lastContactedAt',
  latitude: 'latitude',
  longitude: 'longitude',
  demoEmbedUrl: 'demoEmbedUrl',
  demoEmbed: 'demoEmbed',
  demoEmbedType: 'demoEmbedType',
  repertoire: 'repertoire',
  spotifyArtist: 'spotifyArtist',
  spotifyMonthlyListeners: 'spotifyMonthlyListeners'
};

exports.Prisma.BandApplicationCommentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  viewerId: 'viewerId',
  comment: 'comment',
  bandApplicationId: 'bandApplicationId'
};

exports.Prisma.BandApplicationRatingScalarFieldEnum = {
  viewerId: 'viewerId',
  rating: 'rating',
  bandApplicationId: 'bandApplicationId'
};

exports.Prisma.BandApplicationTagScalarFieldEnum = {
  bandApplicationId: 'bandApplicationId',
  tag: 'tag',
  createdAt: 'createdAt',
  createdByViewerId: 'createdByViewerId'
};

exports.Prisma.BandPlayingScalarFieldEnum = {
  name: 'name',
  startTime: 'startTime',
  endTime: 'endTime',
  description: 'description',
  shortDescription: 'shortDescription',
  genre: 'genre',
  instagram: 'instagram',
  spotify: 'spotify',
  facebook: 'facebook',
  website: 'website',
  youtube: 'youtube',
  soundcloud: 'soundcloud',
  areaId: 'areaId',
  eventId: 'eventId',
  slug: 'slug',
  photo: 'photo',
  announcementTime: 'announcementTime',
  id: 'id'
};

exports.Prisma.CardTransactionScalarFieldEnum = {
  clientId: 'clientId',
  cardId: 'cardId',
  depositBefore: 'depositBefore',
  depositAfter: 'depositAfter',
  balanceBefore: 'balanceBefore',
  balanceAfter: 'balanceAfter',
  transactionType: 'transactionType',
  counter: 'counter',
  orderId: 'orderId'
};

exports.Prisma.CrewCardScalarFieldEnum = {
  id: 'id',
  nickname: 'nickname',
  suspended: 'suspended',
  privileged: 'privileged',
  viewerId: 'viewerId',
  validUntil: 'validUntil'
};

exports.Prisma.DeviceScalarFieldEnum = {
  id: 'id',
  lastSeen: 'lastSeen',
  productListId: 'productListId',
  softwareVersion: 'softwareVersion',
  type: 'type'
};

exports.Prisma.DeviceConfigVersionScalarFieldEnum = {
  crc32: 'crc32',
  version: 'version',
  createdAt: 'createdAt'
};

exports.Prisma.DeviceLogScalarFieldEnum = {
  clientId: 'clientId',
  batteryVoltage: 'batteryVoltage',
  usbVoltage: 'usbVoltage',
  deviceId: 'deviceId',
  createdAt: 'createdAt',
  deviceTime: 'deviceTime'
};

exports.Prisma.DevicePrivilegeTokenScalarFieldEnum = {
  id: 'id',
  label: 'label'
};

exports.Prisma.EventScalarFieldEnum = {
  id: 'id',
  name: 'name',
  start: 'start',
  end: 'end',
  eventType: 'eventType',
  bandApplicationStart: 'bandApplicationStart',
  bandApplicationEnd: 'bandApplicationEnd',
  djApplicationEnd: 'djApplicationEnd',
  poster: 'poster',
  description: 'description',
  djApplicationStart: 'djApplicationStart',
  latitude: 'latitude',
  location: 'location',
  longitude: 'longitude'
};

exports.Prisma.GmailRemindersScalarFieldEnum = {
  messageId: 'messageId',
  account: 'account'
};

exports.Prisma.ItemLocationScalarFieldEnum = {
  timeStamp: 'timeStamp',
  latitude: 'latitude',
  longitude: 'longitude',
  payload: 'payload'
};

exports.Prisma.NewsScalarFieldEnum = {
  slug: 'slug',
  title: 'title',
  content: 'content',
  createdAt: 'createdAt'
};

exports.Prisma.NonceScalarFieldEnum = {
  nonce: 'nonce',
  expiresAt: 'expiresAt',
  createdForId: 'createdForId'
};

exports.Prisma.NonceRequestScalarFieldEnum = {
  expiresAt: 'expiresAt',
  createdForId: 'createdForId',
  status: 'status',
  id: 'id'
};

exports.Prisma.OrderScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  payment: 'payment',
  deposit: 'deposit',
  deviceId: 'deviceId',
  crewCardId: 'crewCardId'
};

exports.Prisma.OrderItemScalarFieldEnum = {
  id: 'id',
  orderId: 'orderId',
  amount: 'amount',
  note: 'note',
  name: 'name',
  perUnitPrice: 'perUnitPrice',
  productListId: 'productListId'
};

exports.Prisma.PageScalarFieldEnum = {
  slug: 'slug',
  content: 'content',
  left: 'left',
  right: 'right',
  bottom: 'bottom',
  title: 'title'
};

exports.Prisma.ProductScalarFieldEnum = {
  id: 'id',
  name: 'name',
  price: 'price',
  order: 'order',
  productListId: 'productListId',
  requiresDeposit: 'requiresDeposit'
};

exports.Prisma.ProductAdditivesScalarFieldEnum = {
  id: 'id',
  displayName: 'displayName'
};

exports.Prisma.ProductListScalarFieldEnum = {
  id: 'id',
  name: 'name',
  emoji: 'emoji',
  active: 'active',
  updatedAt: 'updatedAt',
  description: 'description'
};

exports.Prisma.ShortDomainRedirectScalarFieldEnum = {
  slug: 'slug',
  targetUrl: 'targetUrl'
};

exports.Prisma.TwoFactorScalarFieldEnum = {
  account: 'account',
  service: 'service',
  secret: 'secret'
};

exports.Prisma.ViewerScalarFieldEnum = {
  id: 'id',
  displayName: 'displayName',
  email: 'email',
  profilePicture: 'profilePicture',
  slackToken: 'slackToken',
  slackScopes: 'slackScopes',
  updatedAt: 'updatedAt'
};

exports.Prisma.ViewerLocationScalarFieldEnum = {
  id: 'id',
  viewerId: 'viewerId',
  createdAt: 'createdAt',
  latitude: 'latitude',
  longitude: 'longitude',
  payload: 'payload'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.AreaOrderByRelevanceFieldEnum = {
  id: 'id',
  displayName: 'displayName',
  themeColor: 'themeColor'
};

exports.Prisma.AreaOpeningHourOrderByRelevanceFieldEnum = {
  areaId: 'areaId'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.BandApplicationOrderByRelevanceFieldEnum = {
  id: 'id',
  email: 'email',
  bandname: 'bandname',
  genre: 'genre',
  city: 'city',
  facebook: 'facebook',
  demo: 'demo',
  description: 'description',
  contactName: 'contactName',
  contactPhone: 'contactPhone',
  knowsKultFrom: 'knowsKultFrom',
  website: 'website',
  contactedByViewerId: 'contactedByViewerId',
  instagram: 'instagram',
  eventId: 'eventId',
  demoEmbedUrl: 'demoEmbedUrl',
  demoEmbed: 'demoEmbed',
  spotifyArtist: 'spotifyArtist'
};

exports.Prisma.BandApplicationCommentOrderByRelevanceFieldEnum = {
  id: 'id',
  viewerId: 'viewerId',
  comment: 'comment',
  bandApplicationId: 'bandApplicationId'
};

exports.Prisma.BandApplicationRatingOrderByRelevanceFieldEnum = {
  viewerId: 'viewerId',
  bandApplicationId: 'bandApplicationId'
};

exports.Prisma.BandApplicationTagOrderByRelevanceFieldEnum = {
  bandApplicationId: 'bandApplicationId',
  tag: 'tag',
  createdByViewerId: 'createdByViewerId'
};

exports.Prisma.BandPlayingOrderByRelevanceFieldEnum = {
  name: 'name',
  description: 'description',
  shortDescription: 'shortDescription',
  genre: 'genre',
  instagram: 'instagram',
  spotify: 'spotify',
  facebook: 'facebook',
  website: 'website',
  youtube: 'youtube',
  soundcloud: 'soundcloud',
  areaId: 'areaId',
  eventId: 'eventId',
  slug: 'slug',
  photo: 'photo',
  id: 'id'
};

exports.Prisma.CardTransactionOrderByRelevanceFieldEnum = {
  clientId: 'clientId',
  cardId: 'cardId'
};

exports.Prisma.CrewCardOrderByRelevanceFieldEnum = {
  nickname: 'nickname',
  viewerId: 'viewerId'
};

exports.Prisma.DeviceOrderByRelevanceFieldEnum = {
  id: 'id',
  softwareVersion: 'softwareVersion'
};

exports.Prisma.DeviceLogOrderByRelevanceFieldEnum = {
  clientId: 'clientId',
  deviceId: 'deviceId'
};

exports.Prisma.DevicePrivilegeTokenOrderByRelevanceFieldEnum = {
  label: 'label'
};

exports.Prisma.EventOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  poster: 'poster',
  description: 'description',
  location: 'location'
};

exports.Prisma.GmailRemindersOrderByRelevanceFieldEnum = {
  messageId: 'messageId',
  account: 'account'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.NewsOrderByRelevanceFieldEnum = {
  slug: 'slug',
  title: 'title',
  content: 'content'
};

exports.Prisma.NonceOrderByRelevanceFieldEnum = {
  nonce: 'nonce',
  createdForId: 'createdForId'
};

exports.Prisma.NonceRequestOrderByRelevanceFieldEnum = {
  createdForId: 'createdForId',
  id: 'id'
};

exports.Prisma.OrderOrderByRelevanceFieldEnum = {
  deviceId: 'deviceId'
};

exports.Prisma.OrderItemOrderByRelevanceFieldEnum = {
  note: 'note',
  name: 'name'
};

exports.Prisma.PageOrderByRelevanceFieldEnum = {
  slug: 'slug',
  content: 'content',
  left: 'left',
  right: 'right',
  bottom: 'bottom',
  title: 'title'
};

exports.Prisma.ProductOrderByRelevanceFieldEnum = {
  name: 'name'
};

exports.Prisma.ProductAdditivesOrderByRelevanceFieldEnum = {
  id: 'id',
  displayName: 'displayName'
};

exports.Prisma.ProductListOrderByRelevanceFieldEnum = {
  name: 'name',
  emoji: 'emoji',
  description: 'description'
};

exports.Prisma.ShortDomainRedirectOrderByRelevanceFieldEnum = {
  slug: 'slug',
  targetUrl: 'targetUrl'
};

exports.Prisma.TwoFactorOrderByRelevanceFieldEnum = {
  account: 'account',
  service: 'service',
  secret: 'secret'
};

exports.Prisma.ViewerOrderByRelevanceFieldEnum = {
  id: 'id',
  displayName: 'displayName',
  email: 'email',
  profilePicture: 'profilePicture',
  slackToken: 'slackToken',
  slackScopes: 'slackScopes'
};

exports.Prisma.ViewerLocationOrderByRelevanceFieldEnum = {
  id: 'id',
  viewerId: 'viewerId'
};
exports.GenreCategory = exports.$Enums.GenreCategory = {
  Rock: 'Rock',
  Pop: 'Pop',
  Indie: 'Indie',
  Reggae_Ska: 'Reggae_Ska',
  Blues_Funk_Jazz_Soul: 'Blues_Funk_Jazz_Soul',
  Folk_SingerSongwriter_Country: 'Folk_SingerSongwriter_Country',
  Elektro_HipHop: 'Elektro_HipHop',
  Hardrock_Metal_Punk: 'Hardrock_Metal_Punk',
  Other: 'Other',
  DJ: 'DJ'
};

exports.HeardAboutBookingFrom = exports.$Enums.HeardAboutBookingFrom = {
  BYon: 'BYon',
  Newspaper: 'Newspaper',
  Friends: 'Friends',
  Website: 'Website',
  Facebook: 'Facebook',
  Instagram: 'Instagram'
};

exports.PreviouslyPlayed = exports.$Enums.PreviouslyPlayed = {
  Yes: 'Yes',
  OtherFormation: 'OtherFormation',
  No: 'No'
};

exports.DemoEmbedType = exports.$Enums.DemoEmbedType = {
  Unresolvable: 'Unresolvable',
  YouTubeVideo: 'YouTubeVideo',
  YouTubePlaylist: 'YouTubePlaylist',
  BandcampAlbum: 'BandcampAlbum',
  BandcampTrack: 'BandcampTrack',
  SoundcloudUrl: 'SoundcloudUrl',
  SpotifyTrack: 'SpotifyTrack',
  SpotifyArtist: 'SpotifyArtist',
  SpotifyAlbum: 'SpotifyAlbum'
};

exports.BandRepertoire = exports.$Enums.BandRepertoire = {
  ExclusivelyOwnSongs: 'ExclusivelyOwnSongs',
  MostlyOwnSongs: 'MostlyOwnSongs',
  MostlyCoverSongs: 'MostlyCoverSongs',
  ExclusivelyCoverSongs: 'ExclusivelyCoverSongs'
};

exports.CardTransactionType = exports.$Enums.CardTransactionType = {
  TopUp: 'TopUp',
  Charge: 'Charge',
  Cashout: 'Cashout',
  Repair: 'Repair'
};

exports.DeviceType = exports.$Enums.DeviceType = {
  CONTACTLESS_TERMINAL: 'CONTACTLESS_TERMINAL',
  IPAD: 'IPAD'
};

exports.EventType = exports.$Enums.EventType = {
  Kulturspektakel: 'Kulturspektakel',
  Other: 'Other',
  Locker: 'Locker'
};

exports.NonceRequestStatus = exports.$Enums.NonceRequestStatus = {
  Pending: 'Pending',
  Approved: 'Approved',
  Rejected: 'Rejected'
};

exports.OrderPayment = exports.$Enums.OrderPayment = {
  CASH: 'CASH',
  BON: 'BON',
  SUM_UP: 'SUM_UP',
  VOUCHER: 'VOUCHER',
  FREE_CREW: 'FREE_CREW',
  FREE_BAND: 'FREE_BAND',
  KULT_CARD: 'KULT_CARD'
};

exports.Prisma.ModelName = {
  Area: 'Area',
  AreaOpeningHour: 'AreaOpeningHour',
  BandApplication: 'BandApplication',
  BandApplicationComment: 'BandApplicationComment',
  BandApplicationRating: 'BandApplicationRating',
  BandApplicationTag: 'BandApplicationTag',
  BandPlaying: 'BandPlaying',
  CardTransaction: 'CardTransaction',
  CrewCard: 'CrewCard',
  Device: 'Device',
  DeviceConfigVersion: 'DeviceConfigVersion',
  DeviceLog: 'DeviceLog',
  DevicePrivilegeToken: 'DevicePrivilegeToken',
  Event: 'Event',
  GmailReminders: 'GmailReminders',
  ItemLocation: 'ItemLocation',
  News: 'News',
  Nonce: 'Nonce',
  NonceRequest: 'NonceRequest',
  Order: 'Order',
  OrderItem: 'OrderItem',
  Page: 'Page',
  Product: 'Product',
  ProductAdditives: 'ProductAdditives',
  ProductList: 'ProductList',
  ShortDomainRedirect: 'ShortDomainRedirect',
  TwoFactor: 'TwoFactor',
  Viewer: 'Viewer',
  ViewerLocation: 'ViewerLocation'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }

        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
